const galleryItems = [
  {
    id: 1,
    title: '시크하고 유니크한 블랙&우드 주방',
    category: 'Object',
    img: 'https://public.readdy.ai/ai/img_res/1517fd6f5693170429fcd0ba11d4e443.jpg',
    href: '/kitchendesignprice',
  },
  {
    id: 2,
    title: '아이들과 소통할 수 있는 대면형 아일랜드',
    category: 'Object',
    img: 'https://readdy.ai/api/search-image?query=Bright%20open%20Korean%20kitchen%20with%20large%20island%20counter%2C%20white%20cabinets%2C%20family%20friendly%20layout%2C%20natural%20wood%20bar%20stools%2C%20warm%20sunlight%2C%20clean%20and%20spacious%2C%20realistic%20interior%20photo&width=600&height=480&seq=gallery-kitchen-02&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 3,
    title: '코너 자투리 공간까지 알뜰한 수납',
    category: 'Object',
    img: 'https://readdy.ai/api/search-image?query=Korean%20apartment%20kitchen%20with%20smart%20corner%20storage%20cabinets%2C%20L-shaped%20layout%2C%20light%20gray%20and%20white%20tones%2C%20organized%20shelves%2C%20modern%20handles%2C%20clean%20countertop%2C%20realistic%20interior%20photo&width=600&height=480&seq=gallery-kitchen-03&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 4,
    title: '다양한 키큰장 활용 솔루션',
    category: 'Object',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20kitchen%20with%20tall%20floor-to-ceiling%20storage%20cabinets%2C%20built-in%20refrigerator%2C%20white%20and%20light%20wood%20finish%2C%20minimalist%20style%2C%20bright%20interior%2C%20realistic%20photo&width=600&height=480&seq=gallery-kitchen-04&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 5,
    title: '올 화이트에 스텐 한 스푼',
    category: 'Kitchen',
    img: 'https://readdy.ai/api/search-image?query=All%20white%20Korean%20kitchen%20interior%20with%20stainless%20steel%20sink%20and%20faucet%2C%20glossy%20white%20cabinets%2C%20clean%20countertop%2C%20bright%20natural%20light%2C%20modern%20minimalist%20design%2C%20realistic%20photo&width=600&height=480&seq=gallery-kitchen-05&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 6,
    title: '효율적인 아일랜드',
    category: 'Object',
    img: 'https://readdy.ai/api/search-image?query=Efficient%20kitchen%20island%20in%20Korean%20apartment%2C%20light%20wood%20countertop%2C%20white%20base%20cabinets%2C%20pendant%20lights%20above%2C%20open%20plan%20layout%2C%20warm%20cozy%20atmosphere%2C%20realistic%20interior%20photo&width=600&height=480&seq=gallery-kitchen-06&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 7,
    title: '갤러리 같은 집',
    category: 'Kitchen',
    img: 'https://readdy.ai/api/search-image?query=Gallery-style%20modern%20Korean%20kitchen%20with%20open%20shelving%2C%20curated%20decor%2C%20matte%20white%20cabinets%2C%20terrazzo%20countertop%2C%20artistic%20minimalist%20interior%2C%20bright%20natural%20light%2C%20realistic%20photo&width=600&height=480&seq=gallery-kitchen-07&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 8,
    title: '따뜻함을 주는 우드선반',
    category: 'Object',
    img: 'https://readdy.ai/api/search-image?query=Korean%20kitchen%20with%20warm%20natural%20wood%20open%20shelves%2C%20white%20walls%2C%20ceramic%20dishes%20and%20plants%20on%20shelves%2C%20cozy%20and%20inviting%20atmosphere%2C%20soft%20warm%20lighting%2C%20realistic%20interior%20photo&width=600&height=480&seq=gallery-kitchen-08&orientation=landscape',
    href: '/kitchendesignprice',
  },
  {
    id: 9,
    title: '수직 수평에 진심인 팀',
    category: 'News',
    img: 'https://readdy.ai/api/search-image?query=Perfectly%20aligned%20modern%20Korean%20kitchen%20cabinets%2C%20precise%20installation%2C%20clean%20straight%20lines%2C%20light%20gray%20finish%2C%20professional%20craftsmanship%2C%20bright%20interior%2C%20realistic%20photo&width=600&height=480&seq=gallery-kitchen-09&orientation=landscape',
    href: '/kitchendesignprice',
  },
];

export default function GallerySection() {
  return (
    <section
      className="w-full py-20 px-6 relative"
      style={{
        backgroundImage: 'url(https://readdy.ai/api/search-image?query=Soft%20blurred%20modern%20kitchen%20interior%20background%2C%20light%20beige%20and%20white%20tones%2C%20natural%20wood%20textures%2C%20warm%20ambient%20lighting%2C%20clean%20and%20airy%20atmosphere%2C%20out%20of%20focus%20bokeh%20style%2C%20minimal%20and%20elegant&width=1920&height=1080&seq=gallery-bg-kitchen-01&orientation=landscape)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="absolute inset-0 bg-white/70"></div>
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
            지금 주방 사진을 보내주세요,
            <br />
            대구·경북 맞춤 견적을 바로 드립니다.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {galleryItems.map((item) => (
            <a
              key={item.id}
              href={item.href}
              className="group relative overflow-hidden rounded-lg cursor-pointer block"
            >
              <div className="w-full h-64 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-end">
                <div className="p-4 text-white translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <p className="text-xs text-gray-300 mb-1">{item.category}</p>
                  <h4 className="text-sm font-semibold">{item.title}</h4>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* 텍스트 블록 */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white/80 rounded-lg p-6">
            <p className="text-sm text-gray-700 leading-relaxed">
              20년 된 대구 구축 아파트, 낡은 싱크대 때문에 불편하시죠?<br />
              클릭 한 번으로 새 주방으로 바꿀 수 있어요!
            </p>
          </div>
          <div className="bg-white/80 rounded-lg p-6">
            <p className="text-sm text-gray-700 leading-relaxed">
              경북 30평대 아파트, 답답한 ㄱ자 주방을 바꾸고 싶으신가요?<br />
              아이들과 함께 쓰기 좋은 넓은 아일랜드 주방, 지금 시작해보세요!
            </p>
          </div>
          <div className="bg-white/80 rounded-lg p-6">
            <p className="text-sm text-gray-700 leading-relaxed">
              대구 신혼집 빌라, 주방만 고쳐도 집 분위기가 달라집니다.<br />
              꿈꾸던 신혼 주방, 지금 무료 견적으로 확인해보세요!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
